import { getMetaString } from "components/MetaChatMessage";
import { messageMap } from "services/messageMap";
import { MiddlewareStore } from "store/createStore";
import { IChatMessage } from "store/messages/messages.state";
import { DEFAULT_LANGUAGE } from "translations";
import { isMetaEvent } from "../chatSessionListenerUtils";
import { setTranslationStatus } from "store/app/app.actions";

const displayMap = messageMap();

// handles only non meta messages that ARENT chat components;
export const handleTranslate = async (message: IChatMessage, store: MiddlewareStore, session: connect.CustomerChatSession) => {

    // we dont want to translate smartagent chat components
    if (typeof message.content === 'object' || !["MESSAGE", "EVENT"].includes(message.type)) {
        return message;
    }

    if (!store.getState().app.connectedToAgent) return message;

    const { translation, appTextTranslations, language } = store.getState().app

    if (translation?.on && ['AGENT', 'SYSTEM'].includes(message.role)) {

        const toTranslate = message.type === "EVENT"
            ? getMetaString(message, appTextTranslations, language)
            : message.content;

        const { translatedMessage } = await window.bchat.putChatMessage({
            contactId: session.getChatDetails().contactId,
            message: toTranslate!,
        });

        if (translatedMessage) {
            message.content = translatedMessage
            message.isTranslated = true;
            displayMap.set(message.id, message.content)
        }

    }

    return message;

}